// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as DontgetburnedRouteImport } from './routes/dontgetburned'
import { Route as IdacRouteImport } from './routes/idac'
import { Route as IdentityHasAProblemRouteImport } from './routes/identity-has-a-problem'
import { Route as ModernIgaRouteImport } from './routes/modern-iga'
import { Route as PlatformOverviewRouteImport } from './routes/platform-overview'
import { Route as PressKitRouteImport } from './routes/press-kit'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SentRouteImport } from './routes/sent'
import { Route as ShadersRouteImport } from './routes/shaders'
import { Route as SlaRouteImport } from './routes/sla'
import { Route as ThanksDownloadCustomerStoryRouteImport } from './routes/thanks-download-customer-story'
import { Route as ThanksDownloadUarToolkitRouteImport } from './routes/thanks-download-uar-toolkit'
import { Route as ThanksForYourInterestRouteImport } from './routes/thanks-for-your-interest'
import { Route as VsLinxRouteImport } from './routes/vs-linx'
import { Route as VsLumosRouteImport } from './routes/vs-lumos'
import { Route as VsMcpGatewaysRouteImport } from './routes/vs-mcp-gateways'
import { Route as VsMicrosoftEntraIdGovernanceRouteImport } from './routes/vs-microsoft-entra-id-governance'
import { Route as VsMimRouteImport } from './routes/vs-mim'
import { Route as VsOktaIdentityGovernanceRouteImport } from './routes/vs-okta-identity-governance'
import { Route as VsPathlockRouteImport } from './routes/vs-pathlock'
import { Route as VsRunlayerRouteImport } from './routes/vs-runlayer'
import { Route as VsSailpointRouteImport } from './routes/vs-sailpoint'
import { Route as VsSaviyntRouteImport } from './routes/vs-saviynt'
import { Route as VsVezaRouteImport } from './routes/vs-veza'
import { Route as VsZluriRouteImport } from './routes/vs-zluri'
import { Route as AuthorsIndexRouteImport } from './routes/authors/index'
import { Route as AuthorsSlugRouteImport } from './routes/authors/$slug'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as C1AcademyIndexRouteImport } from './routes/c1-academy/index'
import { Route as C1AcademySlugRouteImport } from './routes/c1-academy/$slug'
import { Route as C1Transform2026IndexRouteImport } from './routes/c1-transform-2026/index'
import { Route as C1Transform2026AgendaRouteImport } from './routes/c1-transform-2026/agenda'
import { Route as C1Transform2026RegisterRouteImport } from './routes/c1-transform-2026/register'
import { Route as C1Transform2026ThankYouRouteImport } from './routes/c1-transform-2026/thank-you'
import { Route as C1Transform2026VipRouteImport } from './routes/c1-transform-2026/vip'
import { Route as CareersIndexRouteImport } from './routes/careers/index'
import { Route as CareersJobIdRouteImport } from './routes/careers/$jobId'
import { Route as CustomersIndexRouteImport } from './routes/customers/index'
import { Route as CustomersSlugRouteImport } from './routes/customers/$slug'
import { Route as EngineeringIndexRouteImport } from './routes/engineering/index'
import { Route as EngineeringSlugRouteImport } from './routes/engineering/$slug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary/index'
import { Route as GlossarySlugRouteImport } from './routes/glossary/$slug'
import { Route as GuidesIndexRouteImport } from './routes/guides/index'
import { Route as GuidesSlugRouteImport } from './routes/guides/$slug'
import { Route as IndustrySlugRouteImport } from './routes/industry/$slug'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as IntegrationsMcpServersRouteImport } from './routes/integrations/mcp-servers'
import { Route as LabsIndexRouteImport } from './routes/labs/index'
import { Route as LegalSlugRouteImport } from './routes/legal/$slug'
import { Route as LpSlugRouteImport } from './routes/lp/$slug'
import { Route as NewsIndexRouteImport } from './routes/news/index'
import { Route as PartnersIndexRouteImport } from './routes/partners/index'
import { Route as PartnersSlugRouteImport } from './routes/partners/$slug'
import { Route as PodcastIndexRouteImport } from './routes/podcast/index'
import { Route as PodcastSlugRouteImport } from './routes/podcast/$slug'
import { Route as PricingIndexRouteImport } from './routes/pricing/index'
import { Route as PricingHostingRouteImport } from './routes/pricing/hosting'
import { Route as PricingSupportRouteImport } from './routes/pricing/support'
import { Route as PricingValueRouteImport } from './routes/pricing/value'
import { Route as ProductsSlugRouteImport } from './routes/products/$slug'
import { Route as ProductsAgenticVaultRouteImport } from './routes/products/agentic-vault'
import { Route as ProductsAiAgentAuthorizationRouteImport } from './routes/products/ai-agent-authorization'
import { Route as ProductsAiGatewayRouteImport } from './routes/products/ai-gateway'
import { Route as ProductsIdentitySecurityPlatformRouteImport } from './routes/products/identity-security-platform'
import { Route as RegisterSlugRouteImport } from './routes/register/$slug'
import { Route as ResourcesSlugRouteImport } from './routes/resources/$slug'
import { Route as SolutionsSlugRouteImport } from './routes/solutions/$slug'
import { Route as TalksIndexRouteImport } from './routes/talks/index'
import { Route as TalksSlugRouteImport } from './routes/talks/$slug'
import { Route as BlogPagePageRouteImport } from './routes/blog/page/$page'
import { Route as EngineeringPagePageRouteImport } from './routes/engineering/page/$page'
import { Route as IntegrationsCategoryIndexRouteImport } from './routes/integrations/$category/index'
import { Route as IntegrationsCategorySlugRouteImport } from './routes/integrations/$category/$slug'
import { Route as LabsLabsIndexRouteImport } from './routes/labs/labs/index'
import { Route as LabsLabsSlugRouteImport } from './routes/labs/labs/$slug'
import { Route as LabsResearchIndexRouteImport } from './routes/labs/research/index'
import { Route as LabsResearchSlugRouteImport } from './routes/labs/research/$slug'
import { Route as NewsPressReleaseSlugRouteImport } from './routes/news/press-release/$slug'
import { Route as SolutionsTeamsSlugRouteImport } from './routes/solutions/teams/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DevelopersRoute = DevelopersRouteImport.update({
            id: '/developers',path: '/developers',getParentRoute: () => rootRouteImport
          })
const DontgetburnedRoute = DontgetburnedRouteImport.update({
            id: '/dontgetburned',path: '/dontgetburned',getParentRoute: () => rootRouteImport
          })
const IdacRoute = IdacRouteImport.update({
            id: '/idac',path: '/idac',getParentRoute: () => rootRouteImport
          })
const IdentityHasAProblemRoute = IdentityHasAProblemRouteImport.update({
            id: '/identity-has-a-problem',path: '/identity-has-a-problem',getParentRoute: () => rootRouteImport
          })
const ModernIgaRoute = ModernIgaRouteImport.update({
            id: '/modern-iga',path: '/modern-iga',getParentRoute: () => rootRouteImport
          })
const PlatformOverviewRoute = PlatformOverviewRouteImport.update({
            id: '/platform-overview',path: '/platform-overview',getParentRoute: () => rootRouteImport
          })
const PressKitRoute = PressKitRouteImport.update({
            id: '/press-kit',path: '/press-kit',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const SentRoute = SentRouteImport.update({
            id: '/sent',path: '/sent',getParentRoute: () => rootRouteImport
          })
const ShadersRoute = ShadersRouteImport.update({
            id: '/shaders',path: '/shaders',getParentRoute: () => rootRouteImport
          })
const SlaRoute = SlaRouteImport.update({
            id: '/sla',path: '/sla',getParentRoute: () => rootRouteImport
          })
const ThanksDownloadCustomerStoryRoute = ThanksDownloadCustomerStoryRouteImport.update({
            id: '/thanks-download-customer-story',path: '/thanks-download-customer-story',getParentRoute: () => rootRouteImport
          })
const ThanksDownloadUarToolkitRoute = ThanksDownloadUarToolkitRouteImport.update({
            id: '/thanks-download-uar-toolkit',path: '/thanks-download-uar-toolkit',getParentRoute: () => rootRouteImport
          })
const ThanksForYourInterestRoute = ThanksForYourInterestRouteImport.update({
            id: '/thanks-for-your-interest',path: '/thanks-for-your-interest',getParentRoute: () => rootRouteImport
          })
const VsLinxRoute = VsLinxRouteImport.update({
            id: '/vs-linx',path: '/vs-linx',getParentRoute: () => rootRouteImport
          })
const VsLumosRoute = VsLumosRouteImport.update({
            id: '/vs-lumos',path: '/vs-lumos',getParentRoute: () => rootRouteImport
          })
const VsMcpGatewaysRoute = VsMcpGatewaysRouteImport.update({
            id: '/vs-mcp-gateways',path: '/vs-mcp-gateways',getParentRoute: () => rootRouteImport
          })
const VsMicrosoftEntraIdGovernanceRoute = VsMicrosoftEntraIdGovernanceRouteImport.update({
            id: '/vs-microsoft-entra-id-governance',path: '/vs-microsoft-entra-id-governance',getParentRoute: () => rootRouteImport
          })
const VsMimRoute = VsMimRouteImport.update({
            id: '/vs-mim',path: '/vs-mim',getParentRoute: () => rootRouteImport
          })
const VsOktaIdentityGovernanceRoute = VsOktaIdentityGovernanceRouteImport.update({
            id: '/vs-okta-identity-governance',path: '/vs-okta-identity-governance',getParentRoute: () => rootRouteImport
          })
const VsPathlockRoute = VsPathlockRouteImport.update({
            id: '/vs-pathlock',path: '/vs-pathlock',getParentRoute: () => rootRouteImport
          })
const VsRunlayerRoute = VsRunlayerRouteImport.update({
            id: '/vs-runlayer',path: '/vs-runlayer',getParentRoute: () => rootRouteImport
          })
const VsSailpointRoute = VsSailpointRouteImport.update({
            id: '/vs-sailpoint',path: '/vs-sailpoint',getParentRoute: () => rootRouteImport
          })
const VsSaviyntRoute = VsSaviyntRouteImport.update({
            id: '/vs-saviynt',path: '/vs-saviynt',getParentRoute: () => rootRouteImport
          })
const VsVezaRoute = VsVezaRouteImport.update({
            id: '/vs-veza',path: '/vs-veza',getParentRoute: () => rootRouteImport
          })
const VsZluriRoute = VsZluriRouteImport.update({
            id: '/vs-zluri',path: '/vs-zluri',getParentRoute: () => rootRouteImport
          })
const AuthorsIndexRoute = AuthorsIndexRouteImport.update({
            id: '/authors/',path: '/authors/',getParentRoute: () => rootRouteImport
          })
const AuthorsSlugRoute = AuthorsSlugRouteImport.update({
            id: '/authors/$slug',path: '/authors/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const C1AcademyIndexRoute = C1AcademyIndexRouteImport.update({
            id: '/c1-academy/',path: '/c1-academy/',getParentRoute: () => rootRouteImport
          })
const C1AcademySlugRoute = C1AcademySlugRouteImport.update({
            id: '/c1-academy/$slug',path: '/c1-academy/$slug',getParentRoute: () => rootRouteImport
          })
const C1Transform2026IndexRoute = C1Transform2026IndexRouteImport.update({
            id: '/c1-transform-2026/',path: '/c1-transform-2026/',getParentRoute: () => rootRouteImport
          })
const C1Transform2026AgendaRoute = C1Transform2026AgendaRouteImport.update({
            id: '/c1-transform-2026/agenda',path: '/c1-transform-2026/agenda',getParentRoute: () => rootRouteImport
          })
const C1Transform2026RegisterRoute = C1Transform2026RegisterRouteImport.update({
            id: '/c1-transform-2026/register',path: '/c1-transform-2026/register',getParentRoute: () => rootRouteImport
          })
const C1Transform2026ThankYouRoute = C1Transform2026ThankYouRouteImport.update({
            id: '/c1-transform-2026/thank-you',path: '/c1-transform-2026/thank-you',getParentRoute: () => rootRouteImport
          })
const C1Transform2026VipRoute = C1Transform2026VipRouteImport.update({
            id: '/c1-transform-2026/vip',path: '/c1-transform-2026/vip',getParentRoute: () => rootRouteImport
          })
const CareersIndexRoute = CareersIndexRouteImport.update({
            id: '/careers/',path: '/careers/',getParentRoute: () => rootRouteImport
          })
const CareersJobIdRoute = CareersJobIdRouteImport.update({
            id: '/careers/$jobId',path: '/careers/$jobId',getParentRoute: () => rootRouteImport
          })
const CustomersIndexRoute = CustomersIndexRouteImport.update({
            id: '/customers/',path: '/customers/',getParentRoute: () => rootRouteImport
          })
const CustomersSlugRoute = CustomersSlugRouteImport.update({
            id: '/customers/$slug',path: '/customers/$slug',getParentRoute: () => rootRouteImport
          })
const EngineeringIndexRoute = EngineeringIndexRouteImport.update({
            id: '/engineering/',path: '/engineering/',getParentRoute: () => rootRouteImport
          })
const EngineeringSlugRoute = EngineeringSlugRouteImport.update({
            id: '/engineering/$slug',path: '/engineering/$slug',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const IndustrySlugRoute = IndustrySlugRouteImport.update({
            id: '/industry/$slug',path: '/industry/$slug',getParentRoute: () => rootRouteImport
          })
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
            id: '/integrations/',path: '/integrations/',getParentRoute: () => rootRouteImport
          })
const IntegrationsMcpServersRoute = IntegrationsMcpServersRouteImport.update({
            id: '/integrations/mcp-servers',path: '/integrations/mcp-servers',getParentRoute: () => rootRouteImport
          })
const LabsIndexRoute = LabsIndexRouteImport.update({
            id: '/labs/',path: '/labs/',getParentRoute: () => rootRouteImport
          })
const LegalSlugRoute = LegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => rootRouteImport
          })
const LpSlugRoute = LpSlugRouteImport.update({
            id: '/lp/$slug',path: '/lp/$slug',getParentRoute: () => rootRouteImport
          })
const NewsIndexRoute = NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => rootRouteImport
          })
const PartnersIndexRoute = PartnersIndexRouteImport.update({
            id: '/partners/',path: '/partners/',getParentRoute: () => rootRouteImport
          })
const PartnersSlugRoute = PartnersSlugRouteImport.update({
            id: '/partners/$slug',path: '/partners/$slug',getParentRoute: () => rootRouteImport
          })
const PodcastIndexRoute = PodcastIndexRouteImport.update({
            id: '/podcast/',path: '/podcast/',getParentRoute: () => rootRouteImport
          })
const PodcastSlugRoute = PodcastSlugRouteImport.update({
            id: '/podcast/$slug',path: '/podcast/$slug',getParentRoute: () => rootRouteImport
          })
const PricingIndexRoute = PricingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PricingRoute
          })
const PricingHostingRoute = PricingHostingRouteImport.update({
            id: '/hosting',path: '/hosting',getParentRoute: () => PricingRoute
          })
const PricingSupportRoute = PricingSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => PricingRoute
          })
const PricingValueRoute = PricingValueRouteImport.update({
            id: '/value',path: '/value',getParentRoute: () => PricingRoute
          })
const ProductsSlugRoute = ProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsAgenticVaultRoute = ProductsAgenticVaultRouteImport.update({
            id: '/products/agentic-vault',path: '/products/agentic-vault',getParentRoute: () => rootRouteImport
          })
const ProductsAiAgentAuthorizationRoute = ProductsAiAgentAuthorizationRouteImport.update({
            id: '/products/ai-agent-authorization',path: '/products/ai-agent-authorization',getParentRoute: () => rootRouteImport
          })
const ProductsAiGatewayRoute = ProductsAiGatewayRouteImport.update({
            id: '/products/ai-gateway',path: '/products/ai-gateway',getParentRoute: () => rootRouteImport
          })
const ProductsIdentitySecurityPlatformRoute = ProductsIdentitySecurityPlatformRouteImport.update({
            id: '/products/identity-security-platform',path: '/products/identity-security-platform',getParentRoute: () => rootRouteImport
          })
const RegisterSlugRoute = RegisterSlugRouteImport.update({
            id: '/register/$slug',path: '/register/$slug',getParentRoute: () => rootRouteImport
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/resources/$slug',path: '/resources/$slug',getParentRoute: () => rootRouteImport
          })
const SolutionsSlugRoute = SolutionsSlugRouteImport.update({
            id: '/solutions/$slug',path: '/solutions/$slug',getParentRoute: () => rootRouteImport
          })
const TalksIndexRoute = TalksIndexRouteImport.update({
            id: '/talks/',path: '/talks/',getParentRoute: () => rootRouteImport
          })
const TalksSlugRoute = TalksSlugRouteImport.update({
            id: '/talks/$slug',path: '/talks/$slug',getParentRoute: () => rootRouteImport
          })
const BlogPagePageRoute = BlogPagePageRouteImport.update({
            id: '/blog/page/$page',path: '/blog/page/$page',getParentRoute: () => rootRouteImport
          })
const EngineeringPagePageRoute = EngineeringPagePageRouteImport.update({
            id: '/engineering/page/$page',path: '/engineering/page/$page',getParentRoute: () => rootRouteImport
          })
const IntegrationsCategoryIndexRoute = IntegrationsCategoryIndexRouteImport.update({
            id: '/integrations/$category/',path: '/integrations/$category/',getParentRoute: () => rootRouteImport
          })
const IntegrationsCategorySlugRoute = IntegrationsCategorySlugRouteImport.update({
            id: '/integrations/$category/$slug',path: '/integrations/$category/$slug',getParentRoute: () => rootRouteImport
          })
const LabsLabsIndexRoute = LabsLabsIndexRouteImport.update({
            id: '/labs/labs/',path: '/labs/labs/',getParentRoute: () => rootRouteImport
          })
const LabsLabsSlugRoute = LabsLabsSlugRouteImport.update({
            id: '/labs/labs/$slug',path: '/labs/labs/$slug',getParentRoute: () => rootRouteImport
          })
const LabsResearchIndexRoute = LabsResearchIndexRouteImport.update({
            id: '/labs/research/',path: '/labs/research/',getParentRoute: () => rootRouteImport
          })
const LabsResearchSlugRoute = LabsResearchSlugRouteImport.update({
            id: '/labs/research/$slug',path: '/labs/research/$slug',getParentRoute: () => rootRouteImport
          })
const NewsPressReleaseSlugRoute = NewsPressReleaseSlugRouteImport.update({
            id: '/news/press-release/$slug',path: '/news/press-release/$slug',getParentRoute: () => rootRouteImport
          })
const SolutionsTeamsSlugRoute = SolutionsTeamsSlugRouteImport.update({
            id: '/solutions/teams/$slug',path: '/solutions/teams/$slug',getParentRoute: () => rootRouteImport
          })





const PricingRouteChildren = {
  PricingHostingRoute: PricingHostingRoute,PricingSupportRoute: PricingSupportRoute,PricingValueRoute: PricingValueRoute,PricingIndexRoute: PricingIndexRoute
}

const PricingRouteWithChildren = PricingRoute._addFileChildren(PricingRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,ContactRoute: ContactRoute,DevelopersRoute: DevelopersRoute,DontgetburnedRoute: DontgetburnedRoute,IdacRoute: IdacRoute,IdentityHasAProblemRoute: IdentityHasAProblemRoute,ModernIgaRoute: ModernIgaRoute,PlatformOverviewRoute: PlatformOverviewRoute,PressKitRoute: PressKitRoute,PricingRoute: PricingRouteWithChildren,PrivacyPolicyRoute: PrivacyPolicyRoute,SecurityRoute: SecurityRoute,SentRoute: SentRoute,ShadersRoute: ShadersRoute,SlaRoute: SlaRoute,ThanksDownloadCustomerStoryRoute: ThanksDownloadCustomerStoryRoute,ThanksDownloadUarToolkitRoute: ThanksDownloadUarToolkitRoute,ThanksForYourInterestRoute: ThanksForYourInterestRoute,VsLinxRoute: VsLinxRoute,VsLumosRoute: VsLumosRoute,VsMcpGatewaysRoute: VsMcpGatewaysRoute,VsMicrosoftEntraIdGovernanceRoute: VsMicrosoftEntraIdGovernanceRoute,VsMimRoute: VsMimRoute,VsOktaIdentityGovernanceRoute: VsOktaIdentityGovernanceRoute,VsPathlockRoute: VsPathlockRoute,VsRunlayerRoute: VsRunlayerRoute,VsSailpointRoute: VsSailpointRoute,VsSaviyntRoute: VsSaviyntRoute,VsVezaRoute: VsVezaRoute,VsZluriRoute: VsZluriRoute,AuthorsSlugRoute: AuthorsSlugRoute,BlogSlugRoute: BlogSlugRoute,C1AcademySlugRoute: C1AcademySlugRoute,C1Transform2026AgendaRoute: C1Transform2026AgendaRoute,C1Transform2026RegisterRoute: C1Transform2026RegisterRoute,C1Transform2026ThankYouRoute: C1Transform2026ThankYouRoute,C1Transform2026VipRoute: C1Transform2026VipRoute,CareersJobIdRoute: CareersJobIdRoute,CustomersSlugRoute: CustomersSlugRoute,EngineeringSlugRoute: EngineeringSlugRoute,GlossarySlugRoute: GlossarySlugRoute,GuidesSlugRoute: GuidesSlugRoute,IndustrySlugRoute: IndustrySlugRoute,IntegrationsMcpServersRoute: IntegrationsMcpServersRoute,LegalSlugRoute: LegalSlugRoute,LpSlugRoute: LpSlugRoute,PartnersSlugRoute: PartnersSlugRoute,PodcastSlugRoute: PodcastSlugRoute,ProductsSlugRoute: ProductsSlugRoute,ProductsAgenticVaultRoute: ProductsAgenticVaultRoute,ProductsAiAgentAuthorizationRoute: ProductsAiAgentAuthorizationRoute,ProductsAiGatewayRoute: ProductsAiGatewayRoute,ProductsIdentitySecurityPlatformRoute: ProductsIdentitySecurityPlatformRoute,RegisterSlugRoute: RegisterSlugRoute,ResourcesSlugRoute: ResourcesSlugRoute,SolutionsSlugRoute: SolutionsSlugRoute,TalksSlugRoute: TalksSlugRoute,AuthorsIndexRoute: AuthorsIndexRoute,BlogIndexRoute: BlogIndexRoute,C1AcademyIndexRoute: C1AcademyIndexRoute,C1Transform2026IndexRoute: C1Transform2026IndexRoute,CareersIndexRoute: CareersIndexRoute,CustomersIndexRoute: CustomersIndexRoute,EngineeringIndexRoute: EngineeringIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,GuidesIndexRoute: GuidesIndexRoute,IntegrationsIndexRoute: IntegrationsIndexRoute,LabsIndexRoute: LabsIndexRoute,NewsIndexRoute: NewsIndexRoute,PartnersIndexRoute: PartnersIndexRoute,PodcastIndexRoute: PodcastIndexRoute,TalksIndexRoute: TalksIndexRoute,BlogPagePageRoute: BlogPagePageRoute,EngineeringPagePageRoute: EngineeringPagePageRoute,IntegrationsCategorySlugRoute: IntegrationsCategorySlugRoute,LabsLabsSlugRoute: LabsLabsSlugRoute,LabsResearchSlugRoute: LabsResearchSlugRoute,NewsPressReleaseSlugRoute: NewsPressReleaseSlugRoute,SolutionsTeamsSlugRoute: SolutionsTeamsSlugRoute,IntegrationsCategoryIndexRoute: IntegrationsCategoryIndexRoute,LabsLabsIndexRoute: LabsLabsIndexRoute,LabsResearchIndexRoute: LabsResearchIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)